import {Outlet} from 'react-router';

import {WebViewService} from '@/services/webview/WebViewService';

const AuthenticationPage = () => {
  return <>{!WebViewService.isWebViewActive() && <Outlet />}</>;
};

export default AuthenticationPage;
